<mtm-content-unavailable-message [headingId]="headingId" (goHome)="goHome()" (goBack)="close()" />
